import {Button, Card, CardContent, Stack, Typography} from "@mui/material";
import {CheckCircleOutline, InfoOutlined} from "@mui/icons-material";
import {Link as RouterLink, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AuthService from "../services/auth-service";
import RouteService from "../services/route-service";

export const CheckoutSuccessPage = () => {
    const {t} = useTranslation();
    const isLoggedIn = AuthService.isLoggedIn();
    // Creem appends checkout_id (among others) to the success_url after a payment, a direct visit has none
    const confirmed = new URLSearchParams(useLocation().search).has('checkout_id');

    return (
        <Stack direction="column" alignItems="center" justifyContent="center">
            <Card sx={{width: '100%', maxWidth: '480px', my: 6, textAlign: 'center'}}>
                <CardContent>
                    {confirmed
                        ? <>
                            <CheckCircleOutline color="success" sx={{fontSize: 72}}/>
                            <Typography variant="h5" component="h1" sx={{my: 1}}>
                                {t('checkoutSuccess.title')}
                            </Typography>
                            <Typography sx={{mb: 1}}>{t('checkoutSuccess.message')}</Typography>
                            <Typography color="textSecondary" sx={{mb: 3}}>
                                {isLoggedIn ? t('checkoutSuccess.hintLoggedIn') : t('checkoutSuccess.hint')}
                            </Typography>
                        </>
                        : <>
                            <InfoOutlined color="action" sx={{fontSize: 72}}/>
                            <Typography variant="h5" component="h1" sx={{my: 1}}>
                                {t('checkoutSuccess.direct.title')}
                            </Typography>
                            <Typography color="textSecondary" sx={{mb: 3}}>
                                {t('checkoutSuccess.direct.message')}
                            </Typography>
                        </>}
                    {isLoggedIn
                        ? <Button variant="contained" size="large" fullWidth component={RouterLink}
                                  to={RouteService.HOME}>
                            <Typography fontWeight="bold">{t('checkoutSuccess.toApp')}</Typography>
                        </Button>
                        : <Button variant="contained" size="large" fullWidth onClick={() => AuthService.doLogin()}>
                            <Typography fontWeight="bold">{t('checkoutSuccess.toLogin')}</Typography>
                        </Button>}
                </CardContent>
            </Card>
        </Stack>
    );
};
